import {
  PROJECT_USER_ROLES,
  PROJECT_USER_STATE
} from "../constants/projectUser";
import Store from "../configureStore";
import { PROJECT_ID, PROJECT_USER_ID } from "../constants/storageKeys";
import {
  ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS,
  ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS_IN_TEAM
} from "../constants/otherTexts";
import { ChangeAccessDeniedAction } from "../actions";

export const projectsNumberWithAdminOrManagerRollOfGivenUser = (
  user,
  projects
) => {
  let count = 0;
  projects.forEach(project => {
    let found = false;
    project.project_users.forEach(projectUser => {
      if (
        projectUser.user_id === user.id &&
        projectUser.state === PROJECT_USER_STATE.ACTIVE &&
        isAdminOrManager(projectUser.user_type)
      ) {
        found = true;
      }
    });
    count = found ? count + 1 : count;
  });
  return count;
};

export const isAdminOrManager = role => {
  return (
    role === PROJECT_USER_ROLES.ADMIN || role === PROJECT_USER_ROLES.MANAGER
  );
};

export const hasAdminOrManagerAccessInCurrentProject = () => {
  let init = Store.getState().Init.data;
  const userRoles = init.user_active_types;
  const adminOrManagersRoles = userRoles.filter(role => isAdminOrManager(role));
  return adminOrManagersRoles.length > 0;
};

export const isManagerInProject = userRolesInGivenProject => {
  let init = Store.getState().Init.data;
  const userRolesInCurrentProjects = init.user_active_types;
  const userRoles = userRolesInGivenProject
    ? userRolesInGivenProject
    : userRolesInCurrentProjects;
  return (
    userRoles.filter(role => role === PROJECT_USER_ROLES.MANAGER).length > 0
  );
};

export const isOwnerInProject = userRolesInGivenProject => {
  let init = Store.getState().Init.data;
  const userRolesInCurrentProjects = init.user_active_types;
  const userRoles = userRolesInGivenProject
    ? userRolesInGivenProject
    : userRolesInCurrentProjects;
  return userRoles.filter(role => role === PROJECT_USER_ROLES.OWNER).length > 0;
};

export const isOwnerOrAdminInProject = userRolesInGivenProject => {
  let init = Store.getState().Init.data;
  const userRolesInCurrentProjects = init.user_active_types;
  const userRoles = userRolesInGivenProject
    ? userRolesInGivenProject
    : userRolesInCurrentProjects;
  return (
    userRoles.filter(
      role =>
        role === PROJECT_USER_ROLES.ADMIN || role === PROJECT_USER_ROLES.OWNER
    ).length > 0
  );
};

export const loginUserActiveRolesInGivenProjects = projectUserRows => {
  let loginUser = Store.getState().User.data;
  return projectUserRows
    .filter(
      projectUser =>
        projectUser.state === PROJECT_USER_STATE.ACTIVE &&
        projectUser.user_id === loginUser.id
    )
    .map(projectUser => projectUser.user_type);
};

export const loginUserHasAtLeastThePassedPermissionInOneOfGivenProjectTeams = (
  permission,
  project
) => {
  let loginUser = Store.getState().User.data;
  let init = Store.getState().Init.data;
  const fullAccessRoles = [PROJECT_USER_ROLES.OWNER, PROJECT_USER_ROLES.ADMIN];
  const currentProject = init.project;
  const projectProjectUsers = (project ? project : currentProject)
    .project_users;
  return (
    projectProjectUsers.filter(
      projectUser =>
        projectUser.user_id === loginUser.id &&
        projectUser.state === PROJECT_USER_STATE.ACTIVE &&
        (fullAccessRoles.includes(projectUser.user_type) ||
          projectUser.project_user_teams.filter(team => team[permission])
            .length > 0)
    ).length > 0
  );
};

export const loginUserHasPermissionInGivenTeam = (teamId, permission) => {
  try {
    let init = Store.getState().Init.data;
    const managerProjectUser = init.project.project_users.filter(
      projectUser =>
        projectUser.user_id === init.user.id &&
        projectUser.project_id === parseInt(localStorage.getItem(PROJECT_ID)) &&
        projectUser.user_type !== PROJECT_USER_ROLES.CUSTODIAN &&
        projectUser.state === PROJECT_USER_STATE.ACTIVE
    )[0];
    if (managerProjectUser.user_type === PROJECT_USER_ROLES.MANAGER) {
      const projectUserTeam = managerProjectUser.project_user_teams.filter(
        team => team.team_id === teamId
      );
      return projectUserTeam[0][permission];
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const checkAccessesForManagerPanel = requiredAccesses => {
  // const requiredAccesses = [
  //   PROJECT_USER_ROLES.OWNER,
  //   PROJECT_USER_ROLES.ADMIN,
  //   PROJECT_USER_ROLES.MANAGER
  // ];
  const init = Store.getState().Init.data;
  const loginUserAccessInCurrentProject = init && init.user_active_types;
  let ok = false;
  requiredAccesses.forEach(access => {
    if (init && loginUserAccessInCurrentProject.includes(access)) {
      ok = true;
    }
  });
  return ok;
};

export const checkChangeAccessForToolsItems = (
  addPermission,
  itemName,
  callback
) => {
  if (
    loginUserHasAtLeastThePassedPermissionInOneOfGivenProjectTeams(
      addPermission
    )
  ) {
    callback();
  } else {
    const message = ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS(
      itemName
    );
    Store.dispatch(ChangeAccessDeniedAction.showWarning(message));
  }
};

export const checkChangeAccessForToolsItemsInTeam = (
  addPermission,
  teamId,
  itemName,
  callback
) => {
  if (loginUserHasPermissionInGivenTeam(teamId, addPermission)) {
    callback();
  } else {
    const message = ACCESS_DENIED_WARNING_TEXT_FOR_EDIT_PROJECT_SUB_ITEMS_IN_TEAM(
      itemName
    );
    Store.dispatch(ChangeAccessDeniedAction.showWarning(message));
  }
};
